export default `float i,g,e=1.,s=2.,l;
    vec3 a=vec3(.5);
    p.z-=55.; p=abs(p);
    for(int j=0;j++<8;)
      p=-sign(p)*(abs(abs(abs(p)-2.)-1.)-1.),
      s*=l=-1.55/max(.4,dot(p,p)),
      p=p*l-.535;
    return dot(p,a)/s;
  }`